export default __webpack_public_path__ + "media/images/svg/icon_bg-de3b57bc72975347ecd03a52ba4da42f.svg";